import React from "react";
import "./ProjectPageCard.css";
import type { ProjectPageCardType, ProjectType } from "types";
import { Fade } from "motion";
import { Text } from "foundation";

interface Props {
  content: ProjectPageCardType;
  type: ProjectType;
  index: number;
}

export const ProjectPageCard: React.FC<Props> = ({ content, type, index }) => {
  return (
    <Fade
      className={`project_card project_card-${content.width} project_card-${content.type} project_card-${type}`}
      stagger={index}
    >
      {content.type === "text" ? (
        <Text textStyle="h3">{content.content}</Text>
      ) : (
        <img
          className="project_card__image"
          src={content.content}
          alt={content.type}
        />
      )}
    </Fade>
  );
};
